module.exports = __webpack_public_path__ + "media/images/frontend/ticino-fbdc36ed25cf9bbaf04023d2a0c1aeee.png";